





































import Vue from 'vue';
import {
  OpenCancelAllDebitCardsScreen,
  OpenCancelDebitCardScreen,
} from '@/mixins/get-content-mixins';
import { ExtendMixins } from '@/services';
import { DebitCards } from '@/@types/member';

export default ExtendMixins(
  OpenCancelAllDebitCardsScreen,
  OpenCancelDebitCardScreen,
).extend({
  name: 'DebitCardPaymentMethod',
  props: {
    isCurrent: {
      type: Boolean,
      required: true,
    },
    debitCards: {
      type: Array as () => DebitCards[],
      default: [],
    },
    hasPrimaryCardholder: {
      type: Boolean,
      required: true,
    },
    displayCardName: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    groupTollFreePhone(): string {
      return this.$store.getters.groupTollFreePhone;
    },
  },
  methods: {
    triggerCancel(card): void {
      if (card.dependentType === 'Self') {
        this.openCancelAllDebitCardsScreen({ card });
      } else {
        this.openCancelDebitCardScreen({ card });
      }
    },
    showCardLast4Digits(card): boolean {
      return !(
        card.cardElection &&
        card.cardLast4Digits === null &&
        card.cardRequestDate === null
      );
    },
    getCoveredAccounts(card): string | null {
      if (card.cardPurseType) {
        let cardString = '';
        card.cardPurseType.forEach((type, index) => {
          cardString += type;
          if (index !== card.cardPurseType.length - 1) {
            cardString += ', ';
          }
        });
        return cardString;
      }
      return null;
    },
    getDependentTypeAppString(dependentType): string[] | string {
      let dependentTypeAppString: string[] | string = '';
      switch (dependentType) {
        case 'Self':
          dependentTypeAppString = [
            'debit-card_label_primary-card-holder',
            'global_primary-card-holder',
          ];
          break;
        case 'Spouse':
          dependentTypeAppString = ['debit-card_label_spouse', 'global_spouse'];
          break;
        case 'Child':
          dependentTypeAppString = ['debit-card_label_child', 'global_child'];
          break;
        default:
          dependentTypeAppString = '';
      }
      return dependentTypeAppString;
    },
  },
});
